import React from 'react';
import { FC110 } from '../../../services/scApi';
import { fmt } from '../helpers';
import LookupField from '../../../components/LookupField';

interface Tab3Props {
  formData: Partial<FC110>;
  names: Record<string, string>;
  isEditing: boolean;
  getField: (key: keyof FC110) => FC110[keyof FC110];
  setField: (key: keyof FC110, value: FC110[keyof FC110]) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
  salesAmt: number;
}

const Tab3Extra: React.FC<Tab3Props> = ({
  formData, names, isEditing,
  getField, setField, resolveSingleName,
  salesAmt,
}) => {
  return (
    <div className="page3-layout">

      {/* Left: 備註 + SHIPPING MARK */}
      <div className="page3-left">
        <div className="textarea-group">
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 4 }}>
            <label data-contract-field="fc110_27" style={{ fontWeight: 500 }}>備註</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <label data-contract-field="fc110_271" style={{ fontSize: 13, color: 'var(--text-secondary)' }}>代號:</label>
              <LookupField lookupType="remarkTemplate" style={{ width: 80 }} maxLength={2}
                disabled={!isEditing}
                value={getField('fc110_271') as string}
                onChange={v => setField('fc110_271', v)}
                onCodeConfirm={code => resolveSingleName('remarkTemplate', 'remarkTemplate', code)}
              />
              <span style={{ fontSize: 13, color: 'var(--text-tertiary)' }}>{names.remarkTemplate}</span>
            </div>
          </div>
          <textarea
            disabled={!isEditing}
            placeholder="輸入備註內容"
            value={getField('fc110_27') as string}
            onChange={e => setField('fc110_27', e.target.value)}
          />
        </div>

        <div className="textarea-group">
          <label data-contract-field="fc110_28">SHIPPING MARK</label>
          <textarea
            disabled={!isEditing}
            placeholder="輸入 Shipping Mark"
            value={getField('fc110_28') as string}
            onChange={e => setField('fc110_28', e.target.value)}
          />
        </div>
      </div>

      {/* Right: 信用額度 */}
      <div>
        <div className="checkbox-field" style={{ marginBottom: 16 }}>
          <input
            type="checkbox" id="creditCheck"
            disabled={!isEditing}
            checked={!!formData.fc110_39}
            onChange={e => setField('fc110_39', e.target.checked)}
          />
          <label htmlFor="creditCheck" data-contract-field="fc110_39" style={{ fontWeight: 500 }}>信用額度檢查</label>
        </div>

        <div className="credit-card">
          <div className="card-title">信用額度計算</div>
          <div className="credit-grid">
            {/* 受訂額度 */}
            <div className="credit-group">
              <div className="group-title">受訂額度</div>
              <div className="credit-row">
                <span className="label">受訂額度</span>
                <span className="value">0.00</span>
              </div>
              <div className="credit-row">
                <span className="label">已受訂額度</span>
                <span className="value">0.00</span>
              </div>
              <div className="credit-row highlight">
                <span className="label">可受訂餘額</span>
                <span className="value">0.00</span>
              </div>
            </div>

            {/* 出貨額度 */}
            <div className="credit-group">
              <div className="group-title">出貨額度</div>
              <div className="credit-row">
                <span className="label">出貨額度</span>
                <span className="value">0.00</span>
              </div>
              <div className="credit-row">
                <span className="label">已出貨額度</span>
                <span className="value">0.00</span>
              </div>
              <div className="credit-row highlight">
                <span className="label">可出貨餘額</span>
                <span className="value">0.00</span>
              </div>
            </div>
          </div>

          <div style={{ borderTop: '1px dashed #b7eb8f', marginTop: 16, paddingTop: 12 }}>
            <div className="credit-row deduct">
              <span className="label">本訂單金額</span>
              <span className="value">{fmt(salesAmt)}</span>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default React.memo(Tab3Extra);
